<template> 
    <v-container fluid class="fill-height">
        <Sidebar></Sidebar>
        <div class="px-5">
            <DashboardMainContent></DashboardMainContent>
        </div>
    </v-container>
</template>

<script>
export default {
    components: {
        Sidebar: () => import("./sidebar/Sidebar"),
        DashboardMainContent: () => import("./main/DashboardMainContent")
    }
}
</script>